import React from 'react'
import { Box, Typography } from '@mui/material'
import { AppButtonIcon } from '@components'


export default function AnalyzerCategoriesTableToolbar({ setFullScreen, isFullScreen }) {


    return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} >
        <Typography variant="h6">Price Table sorted by Categories</Typography>
        <AppButtonIcon icon={isFullScreen ? 'xmark' : 'expand-wide'} tooltip='Fullscreen' iconWeight='solid' onClick={setFullScreen}  />
    </Box>
}